import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IDSEntry } from "../models/dsException";
import { throwApiError } from "./apiError";
import { getTerminalId } from "../helpers";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

/**
 * CRETE API call using Axios
 * @returns - Update delivered Short Entry and return same object
 */

export const UpdatePREntryAPI = async (params: IDSEntry, osdNumber: number | string ) => {
  try {
    const url = `${getUrl(ApiType.REFUSAL_ENTRY_UPDATE)}/${osdNumber}`;
    const staticHeaders = getTrackingHeadersMap(ApiType.REFUSAL_ENTRY_UPDATE);
    const headers = {
      ...staticHeaders,
      "OSD-Destination-Terminal": getTerminalId(),
      "OSD-Exception-Number": osdNumber.toString(),
    };
    const response = await axios.put(url, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.updatePREntry, { badRequestOrder: "errorsFirst" });
  }
};
